<template>
  <div class="d-flex w-100 justify-content-center"></div>
</template>
<script>
export default {};
</script>
